import * as React from 'react';
import { IdeaPositionDetailsBuyFeesFragment } from './__generated__/IdeaPositionDetailsBuyFeesFragment';
import { IdeaPositionDetailsSellFeesFragment } from './__generated__/IdeaPositionDetailsSellFeesFragment';
import { Fee } from 'components/PositionDetailsModal/components/Fee';
import { TotalFee } from 'components/PositionDetailsModal/components/Fees';
import { useTranslation } from 'react-i18next';

type Transaction = IdeaPositionDetailsBuyFeesFragment | IdeaPositionDetailsSellFeesFragment;

interface Props {
  transaction: Transaction;
}

const FeesContent: React.FC<Props> = ({ transaction }) => {
  const { t } = useTranslation();
  switch (transaction.__typename) {
    case 'Investment_BuyAndHoldPositionBuy':
      return <Fee title={t('Enter commission value')}>{transaction.enterFeeAmount}</Fee>;
    case 'Investment_BuyAndHoldPositionSell':
      return (
        <>
          <Fee title={t('Sell commission value')}>{transaction.sellFeeAmount}</Fee>
          <Fee title={t('Success commission value')}>{transaction.successFeeAmount}</Fee>
        </>
      );
  }
};

export const Fees: React.FC<Props> = ({ transaction }) => (
  <TotalFee
    totalFeeAmount={transaction.totalFeeAmount}
    fees={<FeesContent transaction={transaction} />}
  />
);
